import repository from 'client/repository';
import asyncBuilder from 'utilities/actions';

const isLoggedIn = asyncBuilder(
    'LOGGED_IN',
    () => repository.auth.isLoggedIn()
);

export default isLoggedIn;